import { useContext } from 'react'
import { ModalContext } from '../context/modal-context'

export const useModal = () => {
	const { dispatch: dispatchModal } = useContext(ModalContext)

	const showModal = modal => {
		dispatchModal({ type: 'set-modal', modalActive: modal })
	}

	const clearModal = modal => {
		dispatchModal({ type: 'clear-modal' })
	}

	return {
		showModal,
		clearModal,
	}
}
